import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";

class Brands extends React.Component {
  render() {
    const data = this.props.data;
    return (
      <div className={` ${"brands"}`}>
        <h2 className={"title"}> برندها</h2>
        <Swiper
          // modules={[Autoplay]}
          spaceBetween={0}
          slidesPerGroup={3}
          // autoplay={{
          //   delay: 2500,
          //   disableOnInteraction: false,
          // }}
          breakpoints={{
            300: { slidesPerView: 1.2 },
            360: { slidesPerView: 2.2 },
            600: { slidesPerView: 3.8 },
            850: { slidesPerView: 4.5 },
            1000: { slidesPerView: 5 },
            1500: { slidesPerView: 6 },
          }}
          className={`${"slider"} ${"brandsSlider"} brands`}
        >
          {data.map((brand) => (
            <SwiperSlide key={brand.id}>
              <div className={"brandSliderItem"}>
                <Link href={`brand/${brand.id}/products`}>
                  <a>
                    <div className={""}>
                      <img src={brand.image} alt={brand.name} />
                    </div>
                  </a>
                </Link>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
}
export default Brands;
